export default {
  noSpace (value) {
    return !/[ \t]/.test(value)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/custom-validation.js